import type { RxJsonSchema } from 'rxdb';
import type { UnitDocType } from '../types/unit';

export const unitSchema: RxJsonSchema<UnitDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 50 },
    abbreviation: { type: 'string', maxLength: 20 },
    type: { type: 'string', enum: ['count', 'weight', 'length', 'volume'] },
    isDefault: { type: 'boolean' },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean' },
  },
  required: ['id', 'name', 'abbreviation', 'type', 'isDefault', 'createdAt', 'updatedAt', '_deleted'],
};
